// extracted by css-extract-rspack-plugin
var _1 = "sk";
var _2 = "sl";
var _3 = "sn";
var _4 = "qi";
var _5 = "so";
var _6 = "gf";
var _7 = "qh";
var _8 = "ez";
var _9 = "sm";
var _a = "sj";
export { _1 as "advantageItem", _2 as "advantageItemInfo", _3 as "appAdvantageImage", _4 as "appAdvantageInfo", _5 as "appStoresLinks", _6 as "descriptionSection", _7 as "goodieAdvantagesComponent", _8 as "imageLoaderComponent", _9 as "imageSection", _a as "wrap" }
